import { useState, useEffect } from 'react'
import './HowToGuides.scss'
import HowToGuideCard from './HowToGuideCard/HowToGuideCard'
import Heading from '../Heading/Heading.jsx'
import Text from '../Text/Text'

const guideGroups = [
  {
    key: 'all',
    displayName: 'All Guides'
  },
  {
    key: 'andis',
    displayName: 'For ANDis',
    contentfulType: 'Andis'
  },
  {
    key: 'howTo',
    displayName: 'How To',
    contentfulType: 'How to'
  },
  {
    key: 'clubs',
    displayName: 'Club Specific',
    contentfulType: 'Clubs'
  },
  {
    key: 'company',
    displayName: 'AND Company',
    contentfulType: 'Company'
  }
]

const HowToGuides = ({
  templateIcon,
  contactsIcon,
  guidesIcon,
  listsIcon,
  otherIcon,
  guideData
}) => {
  const [filter, setFilter] = useState('all')
  const [selectedGuideGroup, setSelectedGuideGroup] = useState(guideGroups[0])
  const [selectedGuides, setSelectedGuides] = useState([])

  useEffect(() => {
    const selectedGroup =
      guideGroups.find((group) => group.key === filter) || guideGroups[0]
    setSelectedGuideGroup(selectedGroup)
    setSelectedGuides(
      filter === 'all'
        ? guideData
        : guideData.filter((card) =>
            card.type.includes(selectedGroup.contentfulType)
          )
    )
  }, [filter])

  return (
    <div>
      <div
        className="how-to-guides-page-legends-group"
        data-testid="legend-group">
        <div className="how-to-guides-page-legends">
          <img src={templateIcon} alt="templates icon" rounded="true" />
          <Text className="icon-text">Templates</Text>
        </div>
        <div className="how-to-guides-page-legends">
          <img src={contactsIcon} alt="contacts icon" rounded="true" />
          <Text className="icon-text">Contacts</Text>
        </div>
        <div className="how-to-guides-page-legends">
          <img src={guidesIcon} alt="guides icon" rounded="true" />
          <Text className="icon-text">Guides</Text>
        </div>
        <div className="how-to-guides-page-legends">
          <img src={listsIcon} alt="lists icon" rounded="true" />
          <Text className="icon-text">Lists</Text>
        </div>
        <div className="how-to-guides-page-legends">
          <img src={otherIcon} alt="other icon" rounded="true" />
          <Text className="icon-text">Other</Text>
        </div>
      </div>

      <div
        className="how-to-guides-filter-buttons-group"
        data-testid="filter-group">
        {guideGroups.map(({ key, displayName }) => (
          <button
            className={`how-to-guides-filter-button ${
              filter === key ? 'selected' : ''
            }`}
            onClick={() => setFilter(key)}
            key={key}>
            {displayName.toUpperCase()}
          </button>
        ))}
      </div>

      <Heading headingSize="h3" className="guide-cards-heading">
        <div className="how-to-guides-page-subheader">A-Z</div>
        {selectedGuideGroup.displayName}
      </Heading>
      <div className="guide-cards" data-testid="guide-cards-test">
        {selectedGuides
          .sort((a, b) => (a.heading > b.heading ? 1 : -1))
          .map((data, index) => (
            <HowToGuideCard
              url={data.url}
              image={data.icon.fields.file.url}
              imageRounded="true"
              headingText={data.heading}
              description={data.description}
              key={index}
            />
          ))}
      </div>
    </div>
  )
}
export default HowToGuides
